import {
  AfterViewInit,
  Component,
  ElementRef,
  Renderer,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { DomSanitizer, SafeValue } from "@angular/platform-browser";
import { environment } from "environments/environment";
import { BreadcrumbService } from "ng5-breadcrumb";
import { Message } from "primeng/primeng";
import { Subscription } from "rxjs";
import { AutenticacaoService } from "./service/autenticacao.service";
import { JwtHelper } from "../../node_modules/angular2-jwt";
import { AppTopBar } from "./app.topbar.component";
import { EventEmitterService } from "./util/emitter-service/emitter-service";
import { EVENT_MSGS_UPDATE } from "./util/emitter-service/nome-evento";
import { bObservableUsuario } from "./util/observable-util";
import { Compiler } from "@angular/core";
import { clearCache } from "./util/rxjs-functions";
enum MenuOrientation {
  STATIC,
  OVERLAY,
  HORIZONTAL,
}

declare var jQuery: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements AfterViewInit, OnDestroy {
  layoutCompact = false;
  layoutMode: MenuOrientation = MenuOrientation.STATIC;
  darkMenu = false;
  profileMode = "top";
  rotateMenuButton: boolean;
  topbarMenuActive: boolean;
  overlayMenuActive: boolean;
  staticMenuDesktopInactive: boolean;
  staticMenuMobileActive: boolean;
  layoutContainer: HTMLDivElement;
  layoutMenuScroller: HTMLDivElement;
  menuClick: boolean;
  topbarItemClick: boolean;
  activeTopbarItem: any;
  documentClickListener: Function;
  resetMenu: boolean;
  userInfo: any;
  linkIFrameSanitized: any;
  displayDialogInMainWindow = false;
  displayDialogPrestacaoConta = false;
  displayDialogInIframe = false;
  lotacaoTemporaria =
    "Conselho Regional de Contabilidade Distrito Federal - CRC-DF";
  bloquearTelaPrincipal = true;
  msgs: Message[] = [];

  private subscription: Subscription;

  @ViewChild("layoutContainer") layourContainerViewChild: ElementRef;
  @ViewChild("layoutMenuScroller") layoutMenuScrollerViewChild: ElementRef;
  @ViewChild(AppTopBar) appTopBar: AppTopBar;

  constructor(
    public renderer: Renderer,
    private observableUser: bObservableUsuario,
    private autenticacaoService: AutenticacaoService,
    private breadcrumbService: BreadcrumbService,
    private jwtHelper: JwtHelper,
    private sanitizer: DomSanitizer,
    private _compiler: Compiler
  ) {
    this.breadcrumbService.addCallbackForRouteRegex(
      "([a-z]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (str) {
          return str
            .replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
              return letter.toUpperCase();
            })
            .replace(/\s+/g, "")
            .replace("-", " ");
        });
      }
    );
    this.subscription = this.observableUser.getValue.subscribe((user) => {
      this.userInfo = user.obj;
      if (this.userInfo != null) {
        if (!window.frameElement) {
          localStorage.removeItem("cpfUsuarioLogadoMainWindow");
          localStorage.setItem("cpfUsuarioLogadoMainWindow", this.userInfo.cpf);
        } else {
          localStorage.removeItem("cpfUsuarioLogadoIframe");
          localStorage.setItem("cpfUsuarioLogadoIframe", this.userInfo.cpf);
        }
      }
    });

    EventEmitterService.get(EVENT_MSGS_UPDATE).subscribe((x) => {
      this.msgs = x;
    });
  }

  verificarToken() {
    if (localStorage.getItem("token")) {
      //this.displayDialogPrestacaoConta=true;
      try {
        if (this.jwtHelper.isTokenExpired(localStorage.getItem("token"))) {
          this.bloquearTelaPrincipal = true;
          this.autenticacaoService.redirectLogin();
        } else {
          if (window.frameElement) {
            this.displayDialogInIframe = true;
          }
          this.bloquearTelaPrincipal = false;
        }
      } catch (e) {
          this.autenticacaoService.redirectLogin();
      }
    }
  }
  
  ngOnInit() {
    console.log("LIMPANDO CACHE");
    clearCache(localStorage.getItem("token"));
    this._compiler.clearCache();
    this.autenticacaoService.obterPermissoesUsuario();

    this.verificarToken();

    this.breadcrumbService.addCallbackForRouteRegex(
      "profissionais-pendentes/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Profissionais Pendentes";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "editar/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Editar";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "editar-homologacao/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Editar";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "visualizar/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Visualizar";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "enviar-cadastro/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Enviar Cadastro";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "alterar-responsavel/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Alterar Responsável";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "alterar-responsavel-homologacao/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Alterar Responsável";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "turma-incluir/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Incluir";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "turma-incluir-homologacao/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Incluir";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "listar-turma/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Listar";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "listar-turma-homologacao/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Listar";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "prestar-conta/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Prestar Conta";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "prestar-conta-homologacao/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Prestar Conta";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "listar-edicao/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Listar";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "prestar-conta-individual/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Prestar Conta Individual";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "incluir-edicao/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Incluir Edição";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "listar-edicao-homologacao/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Listar";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "prestar-conta-individual-homologacao/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Prestar Conta Individual";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "incluir-edicao-homologacao/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Incluir Edição";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "homologar/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Homologar";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "simular/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Relatório Atividade";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "turma-visualizar/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Visualizar Turma";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "turma-visualizar-homologacao/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Visualizar Turma";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "edicao-visualizar/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Edição Visualizar";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "edicao-visualizar-homologacao/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Edição Visualizar";
        });
      }
    );
    this.breadcrumbService.addCallbackForRouteRegex(
      "abrir-recurso/([0-9]*)$",
      (id: string) => {
        return id.replace(/\w\S*/g, function (id) {
          return "Abrir Recurso";
        });
      }
    );
    this.breadcrumbService.hideRouteRegex(
      "([a-z]*)/(simular|homologar|editar|visualizar|enviar-cadastro|abrir-recurso|alterar-responsavel|alterar-responsavel-homologacao|turma-incluir|incluir-edicao|listar-turma|listar-turma-homologacao|prestar-conta|listar-edicao|prestar-conta-individual|edicao-visualizar|turma-visualizar|turma-incluir-homologacao|prestar-conta-homologacao|turma-visualizar-homologacao|editar-homologacao|listar-edicao-homologacao|prestar-conta-individual-homologacao|edicao-visualizar-homologacao|profissionais-pendentes)$"
    );
  }

  returnLinkIframeSanitized(): SafeValue {
    this.verificarToken();
    if (this.linkIFrameSanitized == null) {
      //this.linkIFrameSanitized = this.sanitizer.bypassSecurityTrustResourceUrl(this.linkIframe);
    }

    return this.linkIFrameSanitized;
  }

  showDialog(event: any) {
    this.displayDialogInMainWindow = event;
  }

  verificarTokenEUsuarioLogado() {
    if (
      localStorage.getItem("token") &&
      !this.jwtHelper.isTokenExpired(localStorage.getItem("token")) &&
      localStorage.getItem("cpfUsuarioLogadoMainWindow") ==
        localStorage.getItem("cpfUsuarioLogadoIframe")
    ) {
      this.appTopBar.reiniciarContagemToken();
    } else {
      window.location.href = `${environment.apiEndpoint}/api/Autenticar/login`;
    }
  }

  ngAfterViewInit() {
    if (this.bloquearTelaPrincipal == false) {
      this.layoutContainer = <HTMLDivElement>(
        this.layourContainerViewChild.nativeElement
      );
      this.layoutMenuScroller = <HTMLDivElement>(
        this.layoutMenuScrollerViewChild.nativeElement
      );
    }

    // hides the horizontal submenus or top menu if outside is clicked
    this.documentClickListener = this.renderer.listenGlobal(
      "body",
      "click",
      (event) => {
        if (!this.topbarItemClick) {
          this.activeTopbarItem = null;
          this.topbarMenuActive = false;
        }

        if (!this.menuClick && this.isHorizontal()) {
          this.resetMenu = true;
        }

        this.topbarItemClick = false;
        this.menuClick = false;
      }
    );

    setTimeout(() => {
      jQuery(this.layoutMenuScroller).nanoScroller({ flash: true });
    }, 10);
  }

  onMenuButtonClick(event) {
    this.rotateMenuButton = !this.rotateMenuButton;
    this.topbarMenuActive = false;

    if (this.layoutMode === MenuOrientation.OVERLAY) {
      this.overlayMenuActive = !this.overlayMenuActive;
    } else {
      if (this.isDesktop()) {
        this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
      } else {
        this.staticMenuMobileActive = !this.staticMenuMobileActive;
      }
    }

    event.preventDefault();
  }

  onMenuClick($event) {
    this.menuClick = true;
    this.resetMenu = false;

    if (!this.isHorizontal()) {
      setTimeout(() => {
        jQuery(this.layoutMenuScroller).nanoScroller();
      }, 500);
    }
  }

  onTopbarMenuButtonClick(event) {
    this.topbarItemClick = true;
    this.topbarMenuActive = !this.topbarMenuActive;

    if (this.overlayMenuActive || this.staticMenuMobileActive) {
      this.rotateMenuButton = false;
      this.overlayMenuActive = false;
      this.staticMenuMobileActive = false;
    }

    event.preventDefault();
  }

  onTopbarItemClick(event, item) {
    this.topbarItemClick = true;

    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }

    event.preventDefault();
  }

  isTablet() {
    const width = window.innerWidth;
    return width <= 1024 && width > 640;
  }

  isDesktop() {
    return window.innerWidth > 1024;
  }

  isMobile() {
    return window.innerWidth <= 640;
  }

  isOverlay() {
    return this.layoutMode === MenuOrientation.OVERLAY;
  }

  isHorizontal() {
    return this.layoutMode === MenuOrientation.HORIZONTAL;
  }

  changeToStaticMenu() {
    this.layoutMode = MenuOrientation.STATIC;
  }

  changeToOverlayMenu() {
    this.layoutMode = MenuOrientation.OVERLAY;
  }

  changeToHorizontalMenu() {
    this.layoutMode = MenuOrientation.HORIZONTAL;
  }

  ngOnDestroy() {
    if (this.documentClickListener) {
      this.documentClickListener();
    }

    jQuery(this.layoutMenuScroller).nanoScroller({ flash: true });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts